import { useAuth0 } from '@auth0/auth0-react';
import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import configuration from '../../../configuration';


export interface AssignPromoCodeRequest {
    promoCode: string;
}

export function useAssignPromoCode(
    options?: Omit<
        UseMutationOptions<
            void,
            AxiosError,
            AssignPromoCodeRequest
        >,
        'mutationKey' | 'mutationFn'
    >,
) {
    const { getAccessTokenSilently } = useAuth0();
    return useMutation(
        async (request: AssignPromoCodeRequest) => {            
            const token = await getAccessTokenSilently();
            await axios.post(`${configuration.apiUrl}/donations/promo_code/${request.promoCode}/assign`, request, {
                headers: {
                    'authorization': `bearer ${token}`
                }
            });

        }, options
    );
}